import type { Config, Data, Content } from '@puckeditor/core';
import { type GalleryBlockProps, PUCK_BLOCK_GALLERY } from '~/editor/blocks/gallery/GalleryBlock';
import { type FloorplanBlockProps, PUCK_BLOCK_FLOORPLAN } from '~/editor/blocks/floorplan/FloorplanBlock';
import { type MatterportBlockProps, PUCK_BLOCK_MATTERPORT } from '~/editor/blocks/matterport/MatterportBlock';
import { type ListingBlockProps, PUCK_BLOCK_LISTING } from '~/editor/blocks/listing/ListingBlock';
import { PUCK_BLOCK_HERO } from '~/editor/blocks/hero/HeroBlock';
import { type WysiwygBlockProps, PUCK_BLOCK_WYSIWYG } from '~/editor/blocks/wysiwyg/WysiwygBlock';
import { PUCK_BLOCK_VIDEO, type VideoBlockProps } from '~/editor/blocks/video/VideoBlock';
import { type MapBlockProps, PUCK_BLOCK_MAP } from '~/editor/blocks/map/MapBlock';
import { type MatterportBlockProps as ProfileBlockProps, PUCK_BLOCK_PROFILE } from '~/editor/blocks/profile/ProfileBlock';
import { type DocumentBlockProps, PUCK_BLOCK_DOCUMENT } from '~/editor/blocks/document/DocumentBlock';
import { type PoweredBlockProps, PUCK_BLOCK_POWERED } from '~/editor/blocks/powered/PoweredBlock';
import { type GridBlockProps, PUCK_BLOCK_GRID } from '~/editor/blocks/grid/GridBlock';
import { PUCK_BLOCK_TAB, type TabBlockProps } from '~/editor/blocks/tab/TabBlock';
import { PUCK_BLOCK_FEATURE } from '~/editor/blocks/feature/FeatureBlock';
import type { FeatureBlockProps } from '~/editor/blocks/feature/FeatureBlockProps';
import { type ContactBlockProps, PUCK_BLOCK_CONTACT } from '~/editor/blocks/contact/ContactBlock';
import type { HeroBlockProps } from '~/editor/blocks/hero/HeroBlockProps';

export const PUCK_CONFIG = {
	components: {
		Hero: PUCK_BLOCK_HERO,
		Video: PUCK_BLOCK_VIDEO,
		Floorplan: PUCK_BLOCK_FLOORPLAN,
		Gallery: PUCK_BLOCK_GALLERY,
		Matterport: PUCK_BLOCK_MATTERPORT,
		Listing: PUCK_BLOCK_LISTING,
		Wysiwyg: PUCK_BLOCK_WYSIWYG,
		Profile: PUCK_BLOCK_PROFILE,
		Map: PUCK_BLOCK_MAP,
		Document: PUCK_BLOCK_DOCUMENT,
		Powered: PUCK_BLOCK_POWERED,
		Grid: PUCK_BLOCK_GRID,
		Tab: PUCK_BLOCK_TAB,
		Feature: PUCK_BLOCK_FEATURE,
		Contact: PUCK_BLOCK_CONTACT,
	},
} satisfies Config;

export type PuckConfig = typeof PUCK_CONFIG;

export type PuckComponents = {
	Hero: HeroBlockProps;
	Floorplan: FloorplanBlockProps;
	Gallery: GalleryBlockProps;
	Matterport: MatterportBlockProps;
	Listing: ListingBlockProps;
	Wysiwyg: WysiwygBlockProps;
	Profile: ProfileBlockProps;
	Map: MapBlockProps;
	Document: DocumentBlockProps;
	Powered: PoweredBlockProps;
	Grid: GridBlockProps;
	Tab: TabBlockProps;
	Feature: FeatureBlockProps;
	Contact: ContactBlockProps;
	Video: VideoBlockProps;
};

export type PuckContent = Content<PuckComponents>;
export type PuckData = Data<PuckComponents>;
